import { useState } from 'react';

const ExitIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);
const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);
const CameraIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
    <circle cx="12" cy="13" r="4"/>
  </svg>
);
const WarnIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);
const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

// ── Dummy data ──────────────────────────────────────────
const SAMPLE_CAMIONS = [
  { id: 1, plaque: 'ABC 1234', entree: '22:14', reglement: 'Espèces', veilleur: 'Karim A.', depart: '06h00', depasse: false },
  { id: 2, plaque: 'TUN 7821', entree: '23:02', reglement: 'CB',      veilleur: 'Karim A.', depart: '07h30', depasse: false },
  { id: 3, plaque: 'FR-892-KL', entree: '20:45', reglement: 'Espèces', veilleur: 'Karim A.', depart: '05h00', depasse: true  },
  { id: 4, plaque: '12 TUN 24', entree: '01:15', reglement: 'CB',      veilleur: 'Karim A.', depart: '08h00', depasse: false },
];

// ── Modal Sortie ────────────────────────────────────────
function ModalSortie({ camion, onClose, onConfirm }) {
  const [motif, setMotif] = useState('');
  const motifs = ['Sortie normale', 'Sortie anticipée', 'Changement de place', 'Incident au départ'];

  return (
    <div className="vv-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="vv-modal">
        <div className="vv-modal-header">
          <div className="vv-modal-title" style={{ color: '#f87171' }}>
            <ExitIcon /> Déclarer une sortie — {camion.plaque}
          </div>
          <button className="vv-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="vv-alert danger">
          <WarnIcon />
          Photo obligatoire — cette action est irréversible et horodatée
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label className="vv-field-label">Motif de sortie *</label>
          <div className="vv-radio-list">
            {motifs.map(m => (
              <label key={m} className="vv-radio-label">
                <input
                  type="radio" name="motif" value={m}
                  checked={motif === m}
                  onChange={() => setMotif(m)}
                  style={{ accentColor: 'var(--pg-blue)' }}
                />
                {m}
              </label>
            ))}
          </div>
        </div>

        <div>
          <label className="vv-field-label">Photo obligatoire *</label>
          <div className="vv-photo-drop">
            <CameraIcon />
            Prendre / charger une photo
          </div>
        </div>

        <div className="vv-modal-actions">
          <button className="vv-btn vv-btn-ghost" onClick={onClose}>Annuler</button>
          <button
            className="vv-btn vv-btn-danger"
            onClick={() => { if (motif) { onConfirm(camion.id, motif); onClose(); } }}
          >
            <CheckIcon /> Confirmer la sortie
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Vue Liste ───────────────────────────────────────────
export default function VueListe() {
  const [search,       setSearch]       = useState('');
  const [activeTab,    setActiveTab]    = useState(0);
  const [camions,      setCamions]      = useState(SAMPLE_CAMIONS);
  const [modalCamion,  setModalCamion]  = useState(null);

  const tabs = ['Tous', 'Présents', 'Récents'];

  const filtered = camions.filter(c =>
    c.plaque.toLowerCase().includes(search.toLowerCase())
  );

  const handleConfirmSortie = (id, motif) => {
    // TODO: axios.put(`/api/camions/${id}/sortie`, { motif })
    setCamions(prev => prev.filter(c => c.id !== id));
  };

  return (
    <>
      <div className="vv-page-header">
        <div>
          <div className="vv-page-title">Camions présents</div>
          <div className="vv-page-sub">{camions.length} véhicule(s) en stationnement actif</div>
        </div>
      </div>

      <div className="vv-content">
        <div className="vv-tabs">
          {tabs.map((t, i) => (
            <div
              key={t}
              className={`vv-tab${activeTab === i ? ' active' : ''}`}
              onClick={() => setActiveTab(i)}
            >
              {t} {i === 0 && `(${camions.length})`}
            </div>
          ))}
        </div>

        <div className="vv-search">
          <SearchIcon />
          <input
            type="text"
            placeholder="Rechercher une plaque…"
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <div className="vv-camion-list">
          {filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--pg-text-muted)', fontSize: '13px' }}>
              Aucun camion trouvé
            </div>
          ) : filtered.map(c => (
            <div key={c.id} className="vv-camion-row">
              <span className={`vv-status-dot${c.depasse ? ' alerte' : ' present'}`} />
              <div>
                <div className="vv-camion-plaque">{c.plaque}</div>
                <div className="vv-camion-meta">Entrée {c.entree} · {c.reglement} · {c.veilleur}</div>
              </div>
              <div>
                <div className={`vv-depart-time${c.depasse ? ' depasse' : ''}`}>{c.depart}</div>
                <div className="vv-depart-label">{c.depasse ? 'départ dépassé' : 'départ estimé'}</div>
              </div>
              <div>
                <button className="vv-btn-sortie" onClick={() => setModalCamion(c)}>
                  <ExitIcon /> Sortie
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {modalCamion && (
        <ModalSortie
          camion={modalCamion}
          onClose={() => setModalCamion(null)}
          onConfirm={handleConfirmSortie}
        />
      )}
    </>
  );
}